/* eslint-disable import/no-default-export */
import { Action, actionCreator, createReducer } from '@trello/redux';
import { TeamType } from 'app/gamma/src/modules/state/models/teams';
import { ProductKeys } from '@atlassiansox/product-store-react';

// Action types

const SET_OVERLAY = Symbol('ui/SET_OVERLAY');
const REMOVE_OVERLAY = Symbol('ui/REMOVE_OVERLAY');

export enum OverlayType {
  CreateBoard = 'create_board',
  ClosedBoards = 'closed_boards',
  CreateTeam = 'create_team',
  ProductStore = 'product_store',
}

type SetOverlayAction = Action<
  typeof SET_OVERLAY,
  {
    overlayType: OverlayType | null;
    teamType?: TeamType | null;
    productKey?: ProductKeys | null;
  }
>;
type RemoveOverlayAction = Action<typeof REMOVE_OVERLAY, null>;

interface OverlayPayload {
  overlayType: string | null;
  teamType: TeamType | null;
  productKey: ProductKeys | null;
}

export type OverlayState = OverlayPayload;

// Reducer
const initialState: OverlayState = {
  overlayType: null,
  teamType: null,
  productKey: null,
};

export default createReducer(initialState, {
  [SET_OVERLAY](state: OverlayState, { payload }: SetOverlayAction) {
    return payload;
  },

  [REMOVE_OVERLAY]() {
    return initialState;
  },
});

// Action creators
export const setOverlay = actionCreator<SetOverlayAction>(SET_OVERLAY);
export const removeOverlay = actionCreator<RemoveOverlayAction>(REMOVE_OVERLAY);
